/*
 * Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, EventEmitter, Output} from '@angular/core';
import {User} from '../../shared/model/user';

@Component({
    selector: 'app-user-search-cell-editor',
    template: `
        <app-auto-search class="col-12 md-4" (userSelected)="selectedUser($event);"
                         [showMeButton]="false" [initialUser]="user" [readonly]="readonly"></app-auto-search>
    `,
    standalone: false
})
export class UserSearchCellEditorComponent {

    params: any;
    userField: string;
    readonly = false;
    user: User;
    @Output() valueChange = new EventEmitter<any>();

    constructor() {
    }

    agInit(params: any): void {
        this.params = params;
        this.readonly = params.readonly;
        if (params.userField) {
            const pieces = params.userField.split('.');
            this.user = params.data;
            pieces.forEach(o => {
                if (this.user) {
                    this.user = this.user[o];
                }
            });
        }
    }

    selectedUser($event: any) {
        this.user = $event;
        if (this.params.onSelectedUser) {
            this.params.onSelectedUser(this.params, this.user);
        } else if (this.params.onSelectedGmin) {
            this.params.onSelectedGmin(this.params, this.user.gmin, this.params.colDef.field);
        }
        this.valueChange.emit(this.user.gmin);
    }

    getValue(): any {
        return this.user;
    }
}
